<template>
  <page-outline :title="$t('toolbox.title_details')">
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <template v-if="!activateSpinner">
            <b-row class="justify-content-start">
          <b-col sm="3" md="2" xl="2">
            <back-button @click="$f7.mainView.router.back()"></back-button>
          </b-col>
          <b-col sm="3" md="4" xl="2">
            <b-button class="btnFilter"
                      @click="onRefresh">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col offset-xl="4" sm="3" md="4" xl="2">
            <b-button class="btnFilter"
                      @click="onAddDataset">
              <i class="fa-light fa-plus fs-14px"></i>
              <span> {{ $t('toolbox.add_dataset') }} </span>
            </b-button>
          </b-col>
          <b-col sm="3" md="4" xl="2">
<!--            <b-button class="btnFilter"-->
<!--                      @click="onImportCSV">-->
<!--              <i class="fa-light fa-plus fs-14px"></i>-->
<!--              <span> {{ $t('toolbox.import_dataset') }} </span>-->
<!--            </b-button>-->
            <b-button class="mb-3 justify-item-end"
                      @click="trigOnImportCSV" variant="primary">
              <i class="fa-light fa-plus "></i>
              <span>{{ $t('toolbox.import_dataset') }}</span>
            </b-button>
            <input
                type="file"
                ref="fileInput"
                class="d-none"
                @change="onImportCSV"
                accept=".csv"
            />
          </b-col>
        </b-row>
        <form-accordion :title="$t('toolbox.details')" :isTitleUpperCase="false" class="mt-25px">
          <b-row class="form-group">
            <b-col sm="3" md="3" xl="2" class="form-group">
              <!--<label for="proxy-active">-->
              <label> {{ $t('toolbox.details_id') }} </label>
              <p>
                {{this.testCase.id}}
              </p>
            </b-col>
            <b-col sm="3" md="3" xl="2" class="form-group">
              <label> {{ $t('toolbox.case_summary') }} </label>
              <p>
<!--                {{this.testCase.case_summary}}-->
                  {{ $t(`toolbox.req_summary_case.${this.testCase.case_summary}`) }}
              </p>
            </b-col>
            <b-col sm="3" md="3" xl="2" class="form-group">
              <!--<label for="proxy-active">-->
              <label> {{ $t('toolbox.last_test_date') }} </label>
             <p v-if="this.testCase.datelastExec.length === 0" class="text-danger">
               {{ $t('toolbox.never_tested') }}
              </p>
              <p v-else>
                {{ date_format(this.testCase.datelastExec) | formatDateTime }}
              </p>
            </b-col>
<!--            <b-col sm="3" md="3" xl="2" class="form-group">
              <label> {{ $t('toolbox.case_type') }} </label>
              <p>
                {{this.testCase.case_type}}
              </p>
            </b-col>-->
            <b-col sm="3" md="3" xl="2" class="form-group">
              <label> {{ $t('toolbox.nb_req_res') }} </label>
              <p>
                {{ this.countSuccess() }}/{{ this.listDataset.filter(item => item.isDefaultDataset === false).length}}
              </p>
            </b-col>
            <b-col sm="3" md="3" xl="2" class="form-group">
              <label> {{ $t('toolbox.last_status') }} </label>
              <template>
                <p>
                    <i title="OK" class="fas fa-check bg-success text-white"
                       v-if="this.testCase.status === 2"
                       style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                    <i title="KO" class="fas fa-multiply bg-danger text-white"
                       v-else-if="this.testCase.status === 0"
                       style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                    <i title="RUN" class="fas fa-hourglass-half text-white"
                       v-else-if="this.testCase.status === 1"
                       style="background-color: orange; border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                    <i  title="Missing configuration" class="fas fa-file-alt"
                        v-else-if="this.testCase.status === 3"
                        style="color: gray; font-size: 20px;"></i>
                    <i title="RUNNING" class="fas fa-hourglass-half"
                       v-else-if="this.testCase.status === 4"
                       style="color: gray; font-size: 20px;"></i>
                    <i title="Not tested"  class="fas fa-minus bg-secondary text-white"
                       v-else-if="this.testCase.status === 5"
                       style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                </p>
              </template>
            </b-col>
<!--        <b-col sm="0" md="0" xl="2" class="form-group"></b-col>-->
          </b-row>
          <b-row class="form-group">
            <b-col sm="12" class="form-group">
              <label> {{ $t('toolbox.case_description') }} </label>
              <p>
                {{ $t(`toolbox.req_description_case.${this.testCase.description_case}`) }}
              </p>
            </b-col>
          </b-row>
        </form-accordion>
        <hr  class="mx-auto mb-4" />

          <div v-for="(dataset, indexDataset) in listDataset" :key="indexDataset">
        <!--Boucler sur le nombre de dataset possible-->
        <form-accordion :title="title_dataset(dataset, indexDataset)" :isTitleUpperCase="false" :open="dataset.isOpen"
                        >
          <form-accordion :title="$t('toolbox.data_request')" :isTitleUpperCase="false" v-if="dataset.request">
            <b-row class="form-group justify-content-start pt-3" >
              <b-col sm="3" md="4" xl="3" class="form-group" v-if="!dataset.isDefaultDataset && !dataset.isNew">
                <!--<label for="proxy-active">-->
                <label> {{ $t('toolbox.creation_date') }} </label>
                <p>
                  {{ date_format(dataset.creation_date) | formatDateTime }}
                </p>
              </b-col>
              <b-col sm="3" md="4" xl="3" class="form-group">
                <label> {{ $t('toolbox.case_description') }} </label>
                <form-read-group-label-input v-if="dataset.isDefaultDataset" :input-value="$t('toolbox.default_dataset')"  :maxLength="512" class="mt-2 pt-0"
                                              :placeholderValue="$t('toolbox.case_description')">
                </form-read-group-label-input>
                <form-read-group-label-input v-else-if="!indexDataset" :input-value="dataset.description_case"  :maxLength="512" class="mt-2 pt-0"
                                              :placeholderValue="$t('toolbox.case_description')">
                </form-read-group-label-input>
                <form-write-group-label-input v-else v-model="dataset.description_case"  :maxLength="512" class="mt-2 pt-0"
                                              :placeholderValue="$t('toolbox.case_description')">
                </form-write-group-label-input>
              </b-col>
              <b-col sm="3" md="4" xl="3" class="form-group" v-if="!dataset.isDefaultDataset && !dataset.isNew">
                <template v-if="!dataset.isDefaultDataset">
                  <label> {{ $t('toolbox.dataset_last_date_test') }} </label>
                  <p v-if="dataset.history.length === 0" class="text-danger">
                    {{ $t('toolbox.never_tested') }}
                  </p>
                  <p v-else>
                    {{ date_format(dataset.history[0].execution) | formatDateTime}}
                  </p>
                </template>
              </b-col>
            </b-row>
            <b-row class="justify-content-start">
              <b-col sm="12" xl="3" v-for="(require, index) in requirement_request" :key="index">
<!--                {{require}}-->
<!--                {{dataset}}-->
                <form-read-group-label-input v-if="!dataset.isDefaultDataset && !dataset.isNew && !indexDataset" class="mt-3" :input-value="dataset.request[require.name].value" :disabled="!require.editable || !indexDataset" :maxLength="512"
                                              :inputLabel="$t('toolbox.'+split_form(require.name).name)+split_form(require.name).number"  :placeholderValue="$t('toolbox.'+split_form(require.name).name)+split_form(require.name).number">
                  <i v-if="(dataset.request[require.name].isEmpty ||
                            dataset.request[require.name].error)"
                     title="OK" class="fas fa-multiply bg-danger text-white"
                     style="border-radius: 50%; margin-left:5px;display: inline-flex; justify-content: center; align-items: center;">
                  </i>
                </form-read-group-label-input>
                <form-write-group-label-input v-else class="mt-3" v-model="dataset.request[require.name].value" :disabled="!require.editable" :maxLength="512"
                                              :inputLabel="$t('toolbox.'+split_form(require.name).name)+split_form(require.name).number"  :placeholderValue="$t('toolbox.'+split_form(require.name).name)+split_form(require.name).number">
                  <i v-if="(dataset.request[require.name].isEmpty ||
                            dataset.request[require.name].error)"
                     title="OK" class="fas fa-multiply bg-danger text-white"
                     style="border-radius: 50%; margin-left:5px;display: inline-flex; justify-content: center; align-items: center;">
                  </i>
                </form-write-group-label-input>

              </b-col>
            </b-row>
          </form-accordion>
          <hr  class="mx-auto mb-4" />
          <form-accordion :title="$t('toolbox.response')" :isTitleUpperCase="false">
            <b-row class="justify-content-start">
              <b-col sm="12" xl="3" v-for="(require, index) in requirement_response" :key="index">
<!--                {{require}}-->
<!--                {{dataset.response}}-->
                <form-read-group-label-input v-if="!dataset.isDefaultDataset && !dataset.isNew && !indexDataset" class="mt-3" :input-value="dataset.response[require.name]['value']" :disabled="!require.editable || !indexDataset" :maxLength="512"
                                              :inputLabel="$t('toolbox.'+split_form(require.name).name)+split_form(require.name).number"  :placeholderValue="$t('toolbox.'+split_form(require.name).name)+split_form(require.name).number">
                  <i v-if="(dataset.response[require.name].isEmpty ||
                            dataset.response[require.name].error)"
                     title="OK" class="fas fa-multiply bg-danger text-white"
                     style="border-radius: 50%; margin-left:5px;display: inline-flex; justify-content: center; align-items: center;">
                  </i>
                </form-read-group-label-input>
                <form-write-group-label-input v-else class="mt-3" v-model="dataset.response[require.name]['value']" :disabled="!require.editable" :maxLength="512"
                                              :inputLabel="$t('toolbox.'+split_form(require.name).name)+split_form(require.name).number"  :placeholderValue="$t('toolbox.'+split_form(require.name).name)+split_form(require.name).number">
                  <i v-if="(dataset.response[require.name].isEmpty ||
                            dataset.response[require.name].error)"
                     title="OK" class="fas fa-multiply bg-danger text-white"
                     style="border-radius: 50%; margin-left:5px;display: inline-flex; justify-content: center; align-items: center;">
                  </i>
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <!--Bouton save data et Bouton send again-->
          <hr  class="mx-auto mb-4" v-if="indexDataset" />
          <b-row class="justify-content-center">
            <b-col cols="2" class="d-flex justify-content-center" v-if="(!dataset.isDefaultDataset && dataset.isNew) || indexDataset">
              <b-button
                  @click="action_save(indexDataset+1)">
                <span>{{$t('toolbox.save_data')}}</span>
              </b-button>
            </b-col>

            <b-col cols="2" class="d-flex justify-content-center" v-if="!dataset.isDefaultDataset && !dataset.isNew && indexDataset">
              <b-button
                  @click="deleteDataset(indexDataset+1)">
                <span>{{$t('toolbox.delete_data')}}</span>
              </b-button>
            </b-col>
          </b-row>
          <hr  class="mx-auto mb-4"  v-if="dataset.history.length > 0" />
          <div v-if="dataset.history.length > 0">
          <form-accordion :title="$t('toolbox.history')" :isTitleUpperCase="false">
              <b-table hover
                       class="table table-striped"
                       thead-class="d-none"
                       style="margin-bottom:0"
                       :fields="fields"
                       :items="dataset.history"
                       :empty-text="$t('common.security.no_result')">
                <template #cell(status)="data">
                  <div v-if="data.value === '2'">
                    <i title="OK" class="fas fa-check bg-success text-white"
                       style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                  </div>
                  <div v-else-if="data.value === '0'">
                    <i title="KO" class="fas fa-multiply bg-danger text-white"
                       style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                  </div>
                  <div v-else-if="data.value === '1'">
                    <i title="RUN" class="fas fa-hourglass-half text-white"
                       style="background-color: orange; border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
                    </i>
                  </div>
                  <div v-else-if="data.value === '3'">
                    <i  title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
                  </div>
                  <div v-else-if="data.value === '4'">
                    <i title="Pending" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
                  </div>
                </template>

                <template #cell(execution)="data">
                  {{ getDate(dataset.history[0].execution)}}
                </template>

                <template #cell(action)="data">
<!--                  <b-button variant="danger"-->
<!--                            class="p-1"-->
<!--                            @click="failed_dataset(index+1)"-->
<!--                            v-if="data.item.status === '2' && data.index === dataset.history.length - 1">-->
<!--                    <i class="fa-light fa-times"></i>-->
<!--                  </b-button>-->
                  <i title="Test data failed" class="fas fa-multiply px-1 cursor-pointer" v-if="data.item.status === '2' && data.index === dataset.history.length - 1"  style="color: var(--actionButtonColorBlue); font-size: 15px;" @click="failed_dataset(indexDataset+1)"></i>
                  <i title="Open" class="fas fa-eye px-1 cursor-pointer" v-if="data.item.status !== '3' && data.item.userId === ''"  style="color: var(--actionButtonColorBlue); font-size: 15px;" @click="openHistory(data.item.idVopMessage, data.item.status, 'see')"></i>
                  <i title="Download" class="fas fa-download px-1 cursor-pointer" v-if="data.item.status !== '3' && data.item.userId === ''"  style="color: var(--actionButtonColorBlue); font-size: 15px;" @click="openHistory(data.item.idVopMessage, data.item.status, 'download')"></i>
                </template>
              </b-table>
          </form-accordion>
          </div>
<!--          <b-row class="justify-content-center pt-10px" v-if="!dataset.isDefaultDataset && !dataset.isNew">-->
<!--&lt;!&ndash;            <b-col cols="2">&ndash;&gt;-->
<!--            <b-col class="d-flex justify-content-center">-->
<!--              <b-button variant="danger"-->
<!--                        class="p-1"-->
<!--                        @click="failed_dataset(index+1)">-->
<!--                <i class="fa-light fa-times"></i>-->
<!--                <span>{{$t('toolbox.failed_dataset')}}</span>-->
<!--              </b-button>-->
<!--            </b-col>-->
<!--          </b-row>-->
        </form-accordion>
        <hr  class="mx-auto mb-4" />
        </div>
        <!--FIN Boucler sur le nombre de dataset possible-->

        <!-- Bouton send again test case-->
        <b-row class="justify-content-center pt-10px"  v-if="this.listDataset.filter(item => (item.isDefaultDataset === false || item.isNew === true)).length > 0">
            <b-col cols="2" class="d-flex justify-content-center">
              <b-button
                        class="p-1"
                        @click="failed_testcase">
                <i class="fa-light fa-times"></i>
                <span>{{$t('toolbox.failed_testcase')}}</span>
              </b-button>
          </b-col>
        </b-row>
        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue"
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import {errorMessageAlert} from "@/helpers/alert"
import moment from "moment"
import alpha2Country from "../../data/alpha2Country.json"
import {downloadFileWithDefinedHeaders} from "@/helpers/download";

export default {
  name: 'RequestTBDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
  },
  computed: {
    fields () {
      let fields
      fields = [
        { key: 'status', label: this.$i18n.t('toolbox.history_status'), class: 'text-center', sortable: false },
        { key: 'status_code', label: this.$i18n.t('toolbox.history_status_code'), class: 'text-center', sortable: false },
        { key: 'execution', label: this.$i18n.t('toolbox.history_execution'), class: 'text-center', sortable: false },
        { key: 'action', label: this.$i18n.t('toolbox.history_action'), class: 'text-center', sortable: false }
      ]

      return fields
    }
  },
  props : {
    id : {
      required : true,
      default : -1
    }
  },
  data () {
    return {
      activateSpinner: false,
      countries: alpha2Country.countries.reverse(),
      returnUrl: "",
      testCase : {}, //Info testCase
      requirement_request : [], //Champs Dataset request
      requirement_response : [], //Champs Dataset response
      listDataset: [], //ID Dataset
      defaultDataset: {}, //Default Dataset
    }
  },
  created () {
    this.idAccountTBBulk = this.$route.query.idAccountTBBulk
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur'
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.getTestCaseDetails()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    getDate(date){
      return moment.utc(date).local().format('YYYY-MM-DD HH:mm:ss.SSS')
    },
    defineReturnURL() {
      this.returnUrl = "/requestTB/"
    },
    getTestCaseDetails() {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      let filterConditions = {}

      that.$engine.toolbox.getTestCaseTB(
          filterConditions, this.id
      )
      .then(resp => {
        console.log(resp.data.TestCase)
        if (resp.data && resp.data.TestCase) {
          let aux = resp.data.TestCase.TestCaseInfo
          console.log("Process info")
          console.log(aux)
          this.testCase.id = aux["~Unknown_1"]
          this.testCase.case_summary = aux["~Unknown_2"]
          this.testCase.description_case = aux["~Unknown_3"]
          this.testCase.case_type = aux["~Unknown_4"]
          this.testCase.case_type_detailed = aux["~Unknown_5"]
          this.testCase.tested_field = aux["~Unknown_6"]
          this.testCase.criticality = aux["~Unknown_7"]
          console.log("Process LastExec")
          this.testCase.datelastExec = ""
          if(resp.data.TestCase.LastExec){
            let last = resp.data.TestCase.LastExec
            last = last.replace("T", " ")
            this.testCase.datelastExec = last
          }
          console.log("Process Requirement")
          let requires = []
          if(Array.isArray(resp.data.TestCase.Requirement))
            requires = resp.data.TestCase.Requirement
          else
            requires.push(resp.data.TestCase.Requirement)
          console.log(requires)
          requires.forEach(require => {
            let currentReq = {}
            currentReq.id = require["~Unknown_1"]
            currentReq.name = require["~Unknown_2"]
            currentReq.regex = require["~Unknown_3"]
            currentReq.function = require["~Unknown_4"]
            let isEditable = false
            if(require["~Unknown_5"] !== "0")
              isEditable = true
            currentReq.editable = isEditable
            currentReq.field_request_number = require["~Unknown_6"]
            currentReq.type = require["~Unknown_7"]
            if(currentReq.type==="0")
              this.requirement_request.push(currentReq)
            else
              this.requirement_response.push(currentReq)
          });
          console.log("Require request")
          console.log(this.requirement_request)
          console.log("Require response")
          console.log(this.requirement_response)
          console.log("Process DatasetInfo")
          console.log(resp.data.TestCase.DatasetInfo)
          let datasestinfo = []
          if(Array.isArray(resp.data.TestCase.DatasetInfo))
            datasestinfo = resp.data.TestCase.DatasetInfo
          else
            datasestinfo.push(resp.data.TestCase.DatasetInfo)
          datasestinfo.forEach(row => {
            //On reconstruit chaque dataset a partir des row
            let idDataset = row["~Unknown_1"]
            if(idDataset !== "$NotFound") {
              let idAcc = row["~Unknown_2"]
              let isDefault = false
              if(idAcc.length === 0)
                isDefault = true
              let createdate = row["~Unknown_3"]
              createdate = createdate.replace("T", " ")
              let desc = row["~Unknown_4"]
              let id_field = row["~Unknown_5"]
              let field_name = row["~Unknown_6"]
              let field_value = row["~Unknown_7"]
              let type = row["~Unknown_8"]
              const foundElement = this.listDataset.find(item => item.id === idDataset);
              if (foundElement) {
                if(type==="0")
                  foundElement.request[field_name] = {id : id_field, value : field_value, isEmpty: false, regex_failed : false, error : false}
                else
                  foundElement.response[field_name] = {id: id_field, value: field_value, isEmpty: false, regex_failed : false, error : false}
              } else {
                let value = {
                  isNew : false,
                  request: {},
                  response: {},
                  history: []
                }
                that.requirement_request.forEach(require => {
                  this.$set(value.request, require.name, {id : "-"+require.id, value : "", isEmpty: false, regex_failed : false, error : false})
                })
                that.requirement_response.forEach(require => {
                  this.$set(value.response, require.name, {id : "-"+require.id, value : "", isEmpty: false, regex_failed : false, error : false})
                })
                value.id = idDataset
                value.isDefaultDataset = isDefault
                value.creation_date = createdate
                value.description_case = desc

                if(type==="0")
                  value.request[field_name] = {id : id_field, value : field_value, isEmpty: false, regex_failed : false, error : false}
                else if(type==="1")
                  value.response[field_name] = {id : id_field, value : field_value, isEmpty: false, regex_failed : false, error : false}
                this.listDataset.push(value)
              }
            }
          });
          //Use default dataset or not
          this.defaultDataset = this.listDataset.find(item => item.isDefaultDataset === true);
          if(this.listDataset.some(item => item.isDefaultDataset === false))
          { //Exclure le dataset par defaut
            this.listDataset = this.listDataset.filter(item => item.isDefaultDataset === false);
            //Set empty value on not editable field
            this.listDataset.forEach(dataset => {
              that.requirement_request.forEach(require => {
                if(!require.editable && dataset.request[require.name].length === 0)
                  dataset.request[require.name].value =  this.defaultDataset.request[require.name].value
              })
              that.requirement_response.forEach(require => {
                if(!require.editable && dataset.response[require.name].length === 0)
                  dataset.response[require.name].value =  this.defaultDataset.response[require.name].value
              })
            })
          }
          console.log("Process History")
          console.log(resp.data.TestCase.History)
          let history = []
          //Si c'est un tableau alors on le met a history
          //Sinon on le met a history
          if(Array.isArray(resp.data.TestCase.History))
            history = resp.data.TestCase.History
          else
            history.push(resp.data.TestCase.History)
          history.forEach(row => {
            let idDataset = row["~Unknown_1"]
            if(idDataset !== "$NotFound") {
              let status = row["~Unknown_2"]
              let status_code = row["~Unknown_3"]
              let execution = row["~Unknown_4"]
              let userId = row["~Unknown_5"]
              let idVopMessage = row["~Unknown_6"]
              const foundElement = this.listDataset.find(item => item.id === idDataset);
              if (foundElement) {
                let current_hist = {}
                current_hist.status = status
                current_hist.status_code = status_code
                execution = execution.replace("T", " ")
                execution = this.date_format(execution)
                current_hist.execution = execution
                current_hist.userId = userId
                current_hist.idVopMessage = idVopMessage
                foundElement.history.push(current_hist)
              }
              /*
              let status = row["~Unknown_2"]
              let status_code = row["~Unknown_3"]
              let execution = row["~Unknown_4"]
              let result_status = row["~Unknown_5"]
              let result_status_code = row["~Unknown_6"]
              let result_execution = row["~Unknown_7"]
              const foundElement = this.listDataset.find(item => item.id === idDataset);
              if (foundElement) {
                if(foundElement.history.length === 0) {
                  let current_hist = {}
                  current_hist.status = status
                  current_hist.status_code = status_code
                  execution = execution.replace("T", " ")
                  execution = this.date_format(execution)
                  current_hist.execution = execution
                  foundElement.history.push(current_hist)
                }
                if(result_status.length > 0 ){
                  let result_hist = {}
                  result_hist.status = result_status
                  result_hist.status_code = result_status_code
                  result_execution = result_execution.replace("T", " ")
                  result_execution = this.date_format(result_execution)
                  result_hist.execution = result_execution
                  foundElement.history.push(result_hist)
                }
              }*/
            }
          });
          this.testCase.status = resp.data.TestCase.Status
        }
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    countSuccess() {
      let success = 0
      this.listDataset.forEach(dataset => {
        if(dataset.history.length > 0 &&
            dataset.history[dataset.history.length-1].status === "2")
          //Si on a un ok a la fin
          success++
      })
      return success
    },
    isTestCaseSuccess() {
      return this.countSuccess() === this.listDataset.length
    },
    onRefresh(){
      this.activateSpinner = true
      this.requirement_request = []
      this.requirement_response = []
      this.listDataset=[]
      this.testCase = {}
      this.getTestCaseDetails()
    },
    onAddDataset() {
      console.log("haha")
      //Ajoute un dataset a listDataset
      let newDataset = {
        id : -1,
        isOpen : true,
        isNew : true,
        isDefaultDataset : false,
        request: {},
        response: {},
        history: []
      }
      this.requirement_request.forEach(require => {
        const cur_val = {
          id: "-" + require.id,
          field: require.name,
          value: '',  // <-- toujours vide
          isEmpty: false,
          regex_failed: false,
          error: false
        };
        //Supprimer cette ligne pour ne pas copier la valeur par défaut
        // if(this.defaultDataset !== undefined && 'request' in this.defaultDataset && require.name in this.defaultDataset.request)
        //   cur_val.value =  this.defaultDataset.request[require.name].value
        this.$set(newDataset.request, require.name, cur_val)
      })
      this.requirement_response.forEach(require => {
        let default_value = '';
        if(
            require.editable === false &&
            this.defaultDataset &&
            this.defaultDataset.response &&
            this.defaultDataset.response[require.name] &&
            this.defaultDataset.response[require.name].value
        )
        { //Not editable field : set default value + default dataset
          default_value = this.defaultDataset.response[require.name].value
        }
        const cur_val = {
          id: "-" + require.id,
          field: require.name,
          value: default_value, // par défaut vide
          isEmpty: false,
          regex_failed: false,
          error: false
        };

        this.$set(newDataset.response, require.name, cur_val);
      })
      //this.requirement_response.forEach(require => {
      //  const cur_val = {id : "-"+require.id, field : require.name, value : '', isEmpty : false, regex_failed : false, error : false}
      //  if(this.defaultDataset !== undefined && 'response' in this.defaultDataset && require.name in this.defaultDataset.response)
      //    cur_val.value =  this.defaultDataset.response[require.name].value
      //  this.$set(newDataset.response, require.name, cur_val)
      //})
      console.log(newDataset)
      this.listDataset.push(newDataset)
      this.testCase.status = 5
    },
    trigOnImportCSV(){
      console.log("start importCSV")
      this.$refs.fileInput.click();
    },
    onImportCSV(event) {
      console.log("import todo")
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader()
        let validCSV = true
        reader.onload = (e) => {
          const csvContent = e.target.result
          validCSV = validCSV && this.isCSV(file) &&  this.isCSVContent(csvContent)
          if(validCSV)
            this.parseCSV(csvContent)
          else{
            this.okMessageBox(this.$t('toolbox.import_error_format'))
          }
        };
        reader.readAsText(file);
        this.$refs.fileInput.value = ""
      }
    },
    isCSV (file) {
      const validMimeTypes = ['text/csv', 'application/vnd.ms-excel']
      const extension = file.name.split('.').pop().toLowerCase()
      return validMimeTypes.includes(file.type) && extension === 'csv'
    },
    isCSVContent (content) {
      const lines = content.trim().split('\n')

      const delimiter = content.includes(';') ? ';' : ','
      const firstLineColumns = lines[0].split(delimiter).length

      return lines.every(line => line.split(delimiter).length === firstLineColumns)
    },
    parseCSV(csvContent) {
      const lines = csvContent.trim().split('\r\n')
      const delimiter = csvContent.includes(';') ? ';' : ','
      //const headers = lines.shift().split(delimiter);
      let that = this
      let request = {}
      console.log("check_header")
      const headers = lines[0].split(delimiter);
      const unknown_header = []
      let foundID = false;
      let foundDESC = false;
      headers.forEach(header => {
        if(!this.validHeader(header))
          unknown_header.push(header)
        if(header === "ID_TEST_CASE")
          foundID = true;
        if(header === "DESCRIPTION")
          foundDESC = true;
      })
      if(unknown_header.length > 0) {
        this.okMessageBox(this.$t('toolbox.import_error_unknown_header'))
        return
      }
      if(!foundID || !foundDESC) {
        this.okMessageBox(this.$t('toolbox.import_error_obligatory_field_not_found'))
        return
      }
      request.delimiter = delimiter
      request.content = []
      request.content.push(lines[0])
      lines.slice(0).forEach(lineContent => {
        const content = lineContent.split(delimiter)
        if(content.length > 0 && content[0] === this.testCase.id)
          request.content.push(lineContent)
      })
      if(request.content.length === 1) {
        this.okMessageBox(this.$t('toolbox.import_empty_csv'))
        return
      }
      that.$engine.toolbox.ImportTestCase(
          request
      ).then(resp => {
        if(resp.data.error)
          this.okMessageBox(this.$t('toolbox.import_content_error'))
        else
          this.onRefresh()
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    },
    validHeader(header){
      switch (header){
        case 'ID_TEST_CASE' :
        case 'DESCRIPTION' :
        case 'IBAN' :
        case 'NAME' :
        case 'X_REQUEST_ID' :
        case 'X_RESPONSE_TIMESTAMP' :
        case 'CONTENT_TYPE' :
        case 'NAME_MATCH' :
        case 'ID_MATCH' :
        case 'MATCHED_NAME' :
        case 'ERROR_TYPE' :
        case 'ERROR_CODE' :
        case 'ERROR_STATUS' :
        case 'ERROR_DETAIL' :
        case 'ERROR_INSTANCE' :
        case 'SIREN' :
        case 'SIRET' :
        case 'TVAINTRACOMM' :
        case 'EUID' :
        case 'LEI' :
        case 'BIC' :
        case 'IDENTIFIER' :
        case 'SCHEME_NAME_CODE' :
        case 'SCHEME_NAME_PROPRIETARY' :
        case 'RESPONDING_BICFI' :
        case 'REQUESTING_BICFI' :
        case 'USTRD_INFO' :
        case 'IDENTIFICATION' :
        case 'HTTP_CODE' :
        case 'HTTP_MESSAGE' :
        case 'ERROR_TITLE' :
          return true
        default :
          return false
      }
    },
    check_input_isEmpty(index){
      console.log("check")
      let that = this
      let hasEmpty = false
      that.requirement_request.forEach(require => {
        if (this.listDataset[index - 1].request[require.name].value.length === 0) {
          //Empty value
          console.log(this.listDataset[index-1].request[require.name].id, "is Empty")
          this.listDataset[index-1].request[require.name].isEmpty = true
          hasEmpty = true
        }else
          this.listDataset[index-1].request[require.name].isEmpty = false
      })
      that.requirement_response.forEach(require => {
        if (this.listDataset[index - 1].response[require.name].value.length === 0) {
          //Empty value
          console.log(this.listDataset[index-1].response)
          console.log(this.listDataset[index-1].response[require.name].id, "is Empty")
          this.listDataset[index-1].response[require.name].isEmpty = true
          hasEmpty = true
        }else
          this.listDataset[index-1].response[require.name].isEmpty = false
      })
      return hasEmpty
    },
    action_save(index){
      console.log("save")
      let that = this
      //reset error input
      that.requirement_request.forEach(require => {
        this.listDataset[index-1].request[require.name].isEmpty = false
        this.listDataset[index-1].request[require.name].regex_failed = false
        this.listDataset[index-1].request[require.name].error = false
      })
      that.requirement_response.forEach(require => {
        this.listDataset[index-1].response[require.name].isEmpty = false
        this.listDataset[index-1].response[require.name].regex_failed = false
        this.listDataset[index-1].response[require.name].error = false
      })
      if(this.check_input_isEmpty(index))
        return //form has empty
      let value = {id_dataset : this.listDataset[index-1].id,
        isDefault : this.listDataset[index-1].isDefaultDataset,
        isNew : this.listDataset[index-1].isNew,
        content_length : 0 ,
        content : []
      }
      that.requirement_request.forEach(require => {
        const cur_val = {id_data : this.listDataset[index-1].request[require.name].id, field : require.name,value : this.listDataset[index-1].request[require.name].value, field_id : require.id, messageType : 0}
        if(this.listDataset[index-1].isDefaultDataset)
          cur_val.id_data = -cur_val.id_data
        value.content.push(cur_val)
      })
      that.requirement_response.forEach(require => {
        const cur_val = {id_data : this.listDataset[index-1].response[require.name].id, field : require.name,value : this.listDataset[index-1].response[require.name].value, field_id : require.id, messageType : 1}
        if(this.listDataset[index-1].isDefaultDataset)
          cur_val.id_data = -cur_val.id_data
        value.content.push(cur_val)
      })
      value.content_length = value.content.length
      value.description = this.listDataset[index-1].description_case
      console.log("Value")
      console.log(value)
      if(this.listDataset[index-1].history.length > 0)
      {
        that.$f7.modal({
          title: that.$t('toolbox.popup_delete_history'),
          buttons: [
            {
              text: that.$t('toolbox.popup_delete_history_yes'),
              onClick: function () {
                that.save_dataset(that.id, value, index)
                return
              }
            },
            {
              text: that.$t('toolbox.popup_delete_history_no'),
              onClick: function () {
                return
              }
            }
          ]
        })
      }else{
        this.save_dataset(this.id, value, index)
      }
    },
    save_dataset(id, value, index){
      let that = this
      that.$engine.toolbox.createDataSet(
          id, value
      ).then(resp => {
        let hasError = false
        let isNew = this.listDataset[index-1].isNew
        if(resp.data.action === 0){
          let invalidFields = [];
          if(resp.data.failed_id) {
            let failed_ids = resp.data.failed_id
            that.requirement_request.forEach(require => {
              let id_to_check = this.listDataset[index-1].request[require.name].id
              if(this.listDataset[index-1].isDefaultDataset)
                id_to_check = "-"+id_to_check
              this.listDataset[index - 1].request[require.name].regex_failed = failed_ids.includes(id_to_check);
              if(this.listDataset[index - 1].request[require.name].regex_failed) {
                hasError = true
                invalidFields.push(require.name)
              }
            })
            that.requirement_response.forEach(require => {
              let id_to_check = this.listDataset[index-1].response[require.name].id
              if(this.listDataset[index-1].isDefaultDataset)
                id_to_check = "-"+id_to_check
              this.listDataset[index - 1].response[require.name].regex_failed = failed_ids.includes(id_to_check);
              if(this.listDataset[index - 1].response[require.name].regex_failed) {
                hasError = true
                invalidFields.push(require.name)
              }
            })
            if(invalidFields.length > 0)
            {
              const message = this.$t('toolbox.dataset_field_error')+` ${invalidFields.join(', ')}`;
              this.okMessageBox(message);
            }
          }
          if(resp.data.error) {
            that.requirement_request.forEach(require => {
              this.listDataset[index - 1].request[require.name].error = true
            })
            that.requirement_response.forEach(require => {
              this.listDataset[index - 1].response[require.name].error = true
            })
            hasError = true
            const error_response = resp.data.error
            if(error_response === "new dataset is in db" ||
                error_response === "already exist dataset is in db")
              this.okMessageBox(this.$t('toolbox.already_in_database'))
          }
        }
        if(isNew || this.listDataset[index-1].isDefaultDataset) {
          if (isNew)
            this.listDataset[index - 1].isNew = hasError
          if(!hasError)
            this.onRefresh()
        }else{
          if(!hasError) {
            this.okMessageBox(this.$t('toolbox.data_saved'))
            this.onRefresh()
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    deleteDataset(index){
      if(this.listDataset.length === 1){
        //message d'erreur
        this.okMessageBox(this.$t('toolbox.last_dataset'))
      }else{
        //supprimer un dataset
        console.log("Suppression Dataset")
        let that = this
        let idDataset = this.listDataset[index-1].id
        console.log(idDataset)
        that.$engine.toolbox.deleteDataset(
            idDataset
        ).then(resp => {
          console.log(resp)
          this.onRefresh()
        }).catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    split_form(str){
      const match = str.match(/^([A-Za-z_]+)(\d+)$/);
      if (match) {
        return {
          name: match[1],  // La partie alphabétique
          number: ''
          //number: " "+match[2].toString()  // La partie numérique
        };
      }
      return {
        name:str,
        number:''
      }
    },
    failed_dataset(index){
      let that = this
      console.log("failed dataset", index)
      console.log("failed dataset id", this.listDataset[index-1].id)
      console.log("id testcase", this.testCase.id)
      that.$engine.toolbox.setDatasetResult(
          this.testCase.id,{id : this.listDataset[index-1].id, value : "0"}
      ).then(resp => {
        if(resp.data.result && resp.data.result === "failed")
          this.okMessageBox(this.$t('toolbox.set_testcase_failed'))
        else
          this.onRefresh()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    failed_testcase(){
      console.log("failed testcase", this.testCase.id)
      let that = this
      let nb_item = this.listDataset.length
      let count_req = 0
      let count_failed = 0
      this.listDataset.forEach(dataset =>{
        let id_value = {id : dataset.id, value : "0"}
        that.$engine.toolbox.setDatasetResult(
            this.testCase.id, id_value
        ).then(resp => {
          count_req++
          if(resp.data.result && resp.data.result === "failed")
            count_failed++
          if(count_req === nb_item)
          {
            if(count_failed === nb_item && count_failed > 0)
            { //Si tous erreur alors on affiche une erreur
              this.okMessageBox(this.$t('toolbox.set_testcase_failed'))
            }else
              this.onRefresh()
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    title_dataset(dataset, index){
      if(dataset.isDefaultDataset)
        return this.$t('toolbox.default_dataset')
      else {
        return this.$t('toolbox.dataset') + ' ' + (index + 1)
      }
    },
    date_format(date){
      const cleanedDate = date.includes('+') ? date.split('+')[0] : date;
      return cleanedDate
    },
    openHistory (IdMsg, status, action,  service = 'historyDataSet') {
      let that = this
      const id = IdMsg
      let dataDetails = {}
      this.$engine.tracking.getJSON({service, id, status})
          .then((resp) => {
            if (resp.data) {
              dataDetails.data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
              dataDetails.type = service
              if (action === 'see') {
                that.$bus.emit('popup-json-details', dataDetails)
              } else {
                let data = Buffer.from(resp.data.data, 'base64').toString('utf-8')
                  const fileName = moment().format('YYYYMMDD_hhmmss_') + service + '.txt'
                  const blob = new Blob([data], { type: 'text/plain' })

                  downloadFileWithDefinedHeaders(that, fileName, URL.createObjectURL(blob))
                  that.$f7.alert('', that.$i18n.t('common.txt_downloaded'))

              }
            }
          })
          .catch((error) => {
            errorMessageAlert(error, that)
          })
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
  }
}
</script>
